module.exports = __webpack_public_path__ + "img/committedtodevelopment_notcompleted.a791ce8e.svg";